<template>
  <div class="position-absolute w-100 z-20 overflow-hidden pointer-events-none page-footer-wrap" :style="wrapStyles">
    <div class="position-relative inner-footer" :style="wrapStyles">

      <svg xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg"
           :viewBox="'0 0 ' + winW + ' ' + wrapH">
        <defs>
          <linearGradient id="page4foot-a" x1="75.991%" x2="37.848%" y1="64.807%" y2="-30.001%">
            <stop offset="0%" :stop-color="mainColor"/>
            <stop offset="100%" :stop-color="accent"/>
          </linearGradient>

          <linearGradient
            id="page4foot-c"
            :x1="gradCoords.x1 + '%'"
            :x2="gradCoords.x2 + '%'"
            :y1="gradCoords.y1 + '%'"
            :y2="gradCoords.y2 + '%'"
          >
            <stop offset="0%" :stop-color="mainColor"/>
            <stop offset="100%" :stop-color="accent"/>
          </linearGradient>

          <polygon
            id="page4foot-b"
            :points="'0 ' + wrapH + ' 0 ' + frontPtLow + ' ' + winW + ' ' + frontPtHigh + ' ' + winW + ' ' + wrapH"
          />

          <linearGradient id="page4foot-d" x1="39.436%" x2="60.058%" y1="-24.646%" y2="151.24%">
            <stop offset="0%" :stop-color="mainColor"/>
            <stop offset="100%" :stop-color="accent"/>
          </linearGradient>
          <linearGradient id="page4foot-f" x1="50%" x2="50%" y1="26.741%" y2="100%">
            <stop offset="0%" :stop-color="mainColor"/>
            <stop offset="100%" :stop-color="lightAccent" stop-opacity="0"/>
          </linearGradient>
          <linearGradient id="page4foot-g" x1="50%" x2="50%" y1="26.741%" y2="100%">
            <stop offset="0%" :stop-color="accent"/>
            <stop offset="100%" :stop-color="lightAccent" stop-opacity="0"/>
          </linearGradient>
        </defs>

        <polygon
          fill="url(#page4foot-a)"
          :points="winW + ' ' + wrapH + ' 0 ' + wrapH + ' 0 0 ' + winW + ' ' + backPt"
          ref="backGrad"
        />

        <use fill="url(#page4foot-c)" xlink:href="#page4foot-b" ref="pageGrad"/>
        <circle
          :cx="winW / 2"
          :cy="((wrapH / 2) - 333.5) + bigCy"
          :r="bigR"
          fill="url(#page4foot-d)"
          :fill-opacity="bigFillAlpha"
          opacity=".2"
          ref="bigCirc"
        />
        <circle
          :cx="((winW / 2) - 187.5) + 375.131"
          cy="104.131"
          r="55"
          fill="url(#page4foot-f)"
          fill-opacity=".7"
          transform="rotate(30 375.131 104.131)"
          ref="rightCirc"
        />
        <circle
          :cx="(winW / 2) - 187.5"
          cy="86"
          r="57"
          fill="url(#page4foot-g)"
          fill-opacity=".7"
          ref="leftCirc"
        />
      </svg>

      <div
        class="position-absolute w-100 d-flex flex-column justify-content-center align-items-center user-select-none footer-text"
        :class="[ allowPointer ? 'pointer-events-auto' : '' ]"
        :style="{ height: h + 'px' }"
        @click="handleClick"
        @touchstart="touchstart"
        @touchmove.prevent="touchmove"
        @touchend="touchend"
        ref="footText"
      >
        <span ref="numeral" class="numeral" v-html="numeral + '.'"></span>
        <span ref="keyword" class="keyword" v-html="keyword"></span>
        <span ref="subhead" class="subhead" v-html="subhead"></span>
      </div>

    </div>
  </div>
</template>

<script>
  import { TimelineMax, Power1, Back } from 'gsap'
  import { lighten } from '@/lib/funcs'
  import FooterMixin from '@/components/report/mixins/FooterMixin'

  export default {
    name: 'Foot4',
    mixins: [ FooterMixin ],
    data () {
      return {
        tl: new TimelineMax(),
        gradCoords: {
          x1: 26.435, // -> 115.115
          x2: 56.169, // -> 22.829
          y1: 68.89,  // -> 107.974
          y2: -31.203 // -> 17.737
        },
        bigCy: 395.5,
        bigR: 294.5,
        bigFillAlpha: 0.7 // -> 0.85
      }
    },
    computed: {
      lightAccent () {
        return lighten( this.accent, 178 / 255 )
      }
    },
    methods: {
      setTweens () {
        this.tl.set( this.$refs.keyword, { yPercent: 50, rotationX: 30, rotationY: 30 } )
          .set( this.$refs.subhead, { yPercent: 100 } )
          .set( [ this.$refs.numeral, this.$refs.keyword, this.$refs.subhead, this.$refs.leftCirc, this.$refs.rightCirc, this.$refs.bigCirc ], { opacity: 0 } )
          .set( [ this.$refs.pageGrad, this.$refs.backGrad, this.$refs.footText ], { y: this.wrapH } )
          .set( [ this.$refs.leftCirc, this.$refs.rightCirc, this.$refs.bigCirc ], {
            y: this.wrapH - this.h,
            scale: 0,
            transformOrigin: '50% 50%'
          } )
      },

      tweenIn () {
        this.tl.staggerTo( [ this.$refs.pageGrad, this.$refs.backGrad, this.$refs.footText ], this.time, {
          y: this.wrapH - this.h,
          ease: Power1.easeInOut
        }, this.stagger, 'in' )
          .to( this.$refs.bigCirc, this.time, { opacity: 0.2, scale: 1 }, 'in+=' + (this.time * 0.5) )
          .to( this.$refs.numeral, this.time / 2, { opacity: 1 }, 'in+=' + (this.stagger * 3 + this.time * 0.5) )
          .to( this.$refs.keyword, this.time / 2, {
            opacity: 1,
            rotationX: 0,
            rotationY: 0,
            yPercent: 0
          }, 'in+=' + (this.stagger * 4 + this.time * 0.5) )
          .to( this.$refs.subhead, this.time / 2, {
            opacity: 1,
            yPercent: 0
          }, 'in+=' + (this.stagger * 5 + this.time * 0.5) )
          .staggerTo( [ this.$refs.leftCirc, this.$refs.rightCirc ], this.time / 2, {
            scale: 1,
            opacity: 1,
            ease: Back.easeOut.config( 1.7 )
          }, this.stagger * 2, 'in+=' + (this.time - this.stagger) )
      },

      tweenOut () {
        this.tl.to( this, this.time, {
          backPt: 0,
          frontPtLow: 0,
          frontPtHigh: 0,
          bigCy: this.isSmall ? this.bigCy : 298.5,
          bigFillAlpha: 0.85,
          ease: Power1.easeInOut
        }, 'out' )
          .to( this.gradCoords, this.time, {
            x1: 115.115,
            x2: 22.829,
            y1: 107.974,
            y2: 17.737,
            ease: Power1.easeInOut
          }, 'out' )
          .to( [ this.$refs.backGrad, this.$refs.pageGrad ], this.time, { y: 0, ease: Power1.easeInOut }, 'out' )
          .to( this.$refs.bigCirc, this.time, {
            y: this.isSmall ? '-=0' : 0,
            opacity: this.isSmall ? 0 : 1,
            ease: Power1.easeInOut
          }, 'out' )
          .to( [ this.$refs.footText, this.$refs.leftCirc, this.$refs.rightCirc ], this.time / 2, { opacity: 0 }, 'out' )
          .to( [ this.$refs.leftCirc, this.$refs.rightCirc ], this.time / 2, { scale: 0 }, 'out' )
          .to( this.$refs.keyword, this.time, { yPercent: 50, rotationX: 30, rotationY: 30 }, 'out' )
          .to( this.$refs.subhead, this.time, { yPercent: 100 }, 'out+=' + this.stagger )
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/report/footers/Foot4.vue